import { data } from "../../mockData/_project-mock";
import { dataAddr } from "../../mockData/_address-mock";
import CallApi from "../../util/CallApi";
import { config } from "../../constants";

export const FETCH_PROJECT = "FETCH_PROJECT";
export const FETCH_PROJECT_SUCCESS = "FETCH_PROJECT_SUCCESS";
export const FETCH_PROJECT_FAILURE = "FETCH_PROJECT_FAILURE";
export const FETCH_MSISDN_SUCCESS = "FETCH_MSISDN_SUCCESS";
export const FETCH_MSISDN_FAILURE = "FETCH_MSISDN_FAILURE";
export const FETCH_PROJECT_ADDR = "FETCH_PROJECT_ADDR";
export const FETCH_PROJECT_ADDR_SUCCESS = "FETCH_PROJECT_ADDR_SUCCESS";
export const FETCH_PROJECT_ADDR_FAILURE = "FETCH_PROJECT_ADDR_FAILURE";
export const FETCH_PROJECT_ADDR_LABEL = "FETCH_PROJECT_ADDR_LABEL";
export const FETCH_PROJECT_ADDR_LABEL_SUCCESS = "FETCH_PROJECT_ADDR_LABEL_SUCCESS";
export const FETCH_PROJECT_ADDR_LABEL_FAILURE = "FETCH_PROJECT_ADDR_LABEL_FAILURE";
export const FETCH_ADDRESS_COMPANY = "FETCH_ADDRESS_COMPANY";
export const FETCH_ADDRESS_COMPANY_SUCCESS = "FETCH_ADDRESS_COMPANY_SUCCESS";
export const FETCH_ADDRESS_COMPANY_FAILURE = "FETCH_ADDRESS_COMPANY_FAILURE";
export const FETCH_ADDRESS_DELIVERY = "FETCH_ADDRESS_DELIVERY";
export const FETCH_ADDRESS_DELIVERY_SUCCESS = "FETCH_ADDRESS_DELIVERY_SUCCESS";
export const FETCH_ADDRESS_DELIVERY_FAILURE = "FETCH_ADDRESS_DELIVERY_FAILURE";

const callApi = new CallApi();
const fpe = require("node-fpe");
const cipher = fpe({ password: config.appkey });
const mockup = false;

export const fetchProject = params => dispatch => {
  dispatch({ type: FETCH_PROJECT });
  if (mockup) {
    setTimeout(() => {
      return dispatch({ type: FETCH_PROJECT_SUCCESS, payload: data });
    }, 1000);
  } else {
    return callApi
      .postWithOutToken("/project", params)
      .then(res => {
        const resData = {
          ...res,
          project_encrypt: cipher.encrypt(res.project_id)
        };
        //console.log(resData);
        dispatch({ type: FETCH_PROJECT_SUCCESS, payload: resData });
      })
      .catch(error => dispatch({ type: FETCH_PROJECT_FAILURE }));
  }
};

export const fetchProjectMsisdn = id => dispatch => {
  dispatch({ type: FETCH_PROJECT });
  if (mockup) {
    setTimeout(() => {
      return dispatch({ type: FETCH_MSISDN_SUCCESS, payload: data });
    }, 1000);
  } else {
    return callApi
      .postWithOutToken("/project/msisdn/" + id, {x:1})
      .then(res => {
        const resData = {
          ...res,
          project_encrypt: cipher.encrypt(res.project_id)
        };
        //console.log(resData);
        dispatch({ type: FETCH_PROJECT_SUCCESS, payload: resData });
      })
      .catch(error => dispatch({ type: FETCH_PROJECT_FAILURE }));
  }
};

export const fetchProjectAddr = params => dispatch => {
  dispatch({ type: FETCH_PROJECT_ADDR });
  if (mockup) {
    setTimeout(() => {
      return dispatch({ type: FETCH_PROJECT_ADDR_SUCCESS, payload: dataAddr });
    }, 1000);
  } else {
    return callApi
      .postWithOutToken("/customer/address", params)
      .then(data => {
        dispatch({ type: FETCH_PROJECT_ADDR_SUCCESS, payload: data });
      })
      .catch(error => dispatch({ type: FETCH_PROJECT_ADDR_FAILURE }));
  }
};

export const fetchProjectAddrLabel = () => dispatch => {
  dispatch({ type: FETCH_PROJECT_ADDR_LABEL });
  if (mockup) {
    setTimeout(() => {
      return dispatch({
        type: FETCH_PROJECT_ADDR_LABEL_SUCCESS,
        payload: dataAddr
      });
    }, 1000);
  } else {
    return callApi
      .get("/query/address_label")
      .then(data => {
        dispatch({ type: FETCH_PROJECT_ADDR_LABEL_SUCCESS, payload: data });
      })
      .catch(error => dispatch({ type: FETCH_PROJECT_ADDR_LABEL_FAILURE }));
  }
};

export const fetchAddressCompany = params => dispatch => {
  dispatch({ type: FETCH_ADDRESS_COMPANY });
  if (mockup) {
    setTimeout(() => {
      return dispatch({ type: FETCH_ADDRESS_COMPANY_SUCCESS, payload: dataAddr });
    }, 1000);
  } else {
    return callApi
      .postWithOutToken("/customer/address", params)
      .then(data => {
        dispatch({ type: FETCH_ADDRESS_COMPANY_SUCCESS, payload: data });
      })
      .catch(error => dispatch({ type: FETCH_ADDRESS_COMPANY_FAILURE }));
  }
};
export const fetchAddressDelivery = params => dispatch => {
  dispatch({ type: FETCH_ADDRESS_DELIVERY });
  if (mockup) {
    setTimeout(() => {
      return dispatch({ type: FETCH_ADDRESS_DELIVERY_SUCCESS, payload: dataAddr });
    }, 1000);
  } else {
    return callApi
      .postWithOutToken("/customer/address", params)
      .then(data => {
        dispatch({ type: FETCH_ADDRESS_DELIVERY_SUCCESS, payload: data });
      })
      .catch(error => dispatch({ type: FETCH_ADDRESS_DELIVERY_FAILURE }));
  }
};